import Vue from 'vue'
import router from './router/pc_index'
import Vuex from 'vuex'
import store from '../store/pc_index'
import VueTouch from 'vue-touch'
import moment from 'moment'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import FullCalendar from 'vue-full-calendar'
import VueClipboard from 'vue-clipboard2'
import App from './AppPc'

import 'fullcalendar/dist/fullcalendar.min.css'
import './assets/iconFont/iconfont.css'
import '../static/css/common.styl'

Vue.use(FullCalendar)
Vue.use(VueClipboard)
// Vue.use(Calendar)
Vue.use(Vuex)
Vue.use(VueTouch, {name: 'v-touch'})
// Vue.use(ElementUI)
Vue.use(ElementUI, {
  size: 'medium'
})

Vue.config.productionTip = false

/* Vue全局过滤器 */
Vue.filter('dateFormat', function (date, format) {
  return moment(date).format(format)
})
Vue.filter('typeFormat', function (typeCode) {
  let typeList = ['面试', '请假', '生活', '项目', '出差', '其他', '通知']
  return typeList[typeCode]
})
Vue.filter('colorFormat', function (typeCode) {
  let colorList = ['#3789FD', '#EED239', '#FFAD49', '#52B94F', '#FFAD49', '#EED239', '#52B94F']
  return colorList[typeCode]
})

// Vue.prototype.HOST = 'http://192.168.1.129:8098'
Vue.prototype.HOST = 'http://wx.weitik.com'

const routerList = [
  '/',
  '/report',
  '/addTeamMember'
]
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    console.log('login')
    next()
  } else if (routerList.indexOf(to.path) !== -1) {
    console.log('not login')
    let userNo = store.state.userInfo.user_no
    if (userNo === '') {
      next({ path: '/login' })
    } else {
      next()
    }
  } else if (to.path === '/err') {
    console.log('err')
    next()
  } else {
    next({ path: '/err' })
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created () {
    console.log('创建Pc')
    // store.dispatch('setDayObj')
  }
})



// WEBPACK FOOTER //
// ./src/mainPc.js